<template>
  <div class="taskTabs">
    <ul class="tab">
      <li v-if="activeFile.projectProcessType >= 1" :class="{ 'active' : tabIndex === 1 }" @click="handleTab(1)">{{$t('projectDetailsV2.translation')}}<span>{{fileTaskNumObj.translationTask || 1}}</span></li>
      <li v-if="activeFile.projectProcessType >= 2" :class="{ 'active' : tabIndex === 2 }" @click="handleTab(2)">{{$t('projectDetailsV2.review')}}<span>{{fileTaskNumObj.reviewTheTask || 1}}</span></li>
      <li v-if="activeFile.projectProcessType >= 3" :class="{ 'active' : tabIndex === 3 }" @click="handleTab(3)">{{$t('projectDetailsV2.recheck')}}<span>{{fileTaskNumObj.proofreadingTasks || 1}}</span></li>
    </ul>
    <div class="tab-pane">
      <TaskList :taskType="tabIndex" :projectInfo="projectInfo" :activeFile="activeFile" @updateTaskNum="getFileTaskNum"></TaskList>
    </div>
  </div>
</template>

<script>
import TaskList from './module/taskList';

import { fileTaskNum } from '@/services/assignTaskApi';

export default {
  name: 'TaskTabs',
  props: {
    activeFile: {
      type: Object,
      require: true,
    },
    projectInfo: {
      type: Object,
      require: true,
    },
  },
  components: {
    TaskList
  },
  data () {
    return {
      tabIndex: 1,
      fileInfo: this.activeFile,
      fileTaskNumObj: {},
    }
  },
  mounted () {
  },
  methods: {
    // 获取任务数
    async getFileTaskNum () {
      let { success, result } = await fileTaskNum({
        fileId: this.fileInfo.id,
        userId: 0,
      });
      if (!success) { return; }
      if(result) this.fileTaskNumObj = result;
    },
    // 切换tab页
    handleTab (index) {
      this.tabIndex = index;
    },
  },
  watch: {
    activeFile: {
      handler (newVal) {
        if (JSON.stringify(newVal) === '{}') {
          return;
        }
        this.fileInfo = newVal;
        this.getFileTaskNum();
        this.tabIndex = 1;
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
  @import './assets/style.less';
</style>